"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LocationGrantFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LocationGrantFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.934 1.386c.313-.844-.539-1.652-1.373-1.303L.634 5.908c-.989.414-.769 1.864.298 1.97l6.506.646 1.34 6.65c.204 1.017 1.624 1.126 1.985.153l.67-1.808.617-1.684A1.5 1.5 0 0 1 10 10.44C10 8.495 11.613 7 13.5 7c.115 0 .23.006.343.017l.442-1.185 1.649-4.446Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.476 8h.024c1.366 0 2.5 1.078 2.5 2.44 0 .93-.533 1.732-1.304 2.142-.457.243-.696.542-.696.797v.121a.5.5 0 0 1-1 0v-.121c0-.85.709-1.404 1.226-1.68.468-.249.774-.724.774-1.26C15 9.66 14.343 9 13.5 9a1.504 1.504 0 0 0-1.076.437A1.411 1.411 0 0 0 12 10.439a.5.5 0 0 1-1 0c0-.684.287-1.297.745-1.737A2.53 2.53 0 0 1 13.475 8ZM14 15.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LocationGrantFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LocationGrantFill;
exports["default"] = _default;